<template>
  <div class="tout">
    <h1 class="white--text hidden-md-and-up mobile" align="center" >S'inscrire sur hiropay</h1>
    <v-layout row wrap>
      <v-flex xs12 md6 first hidden-sm-and-down>
        <div id="first">
          <div class="container" text-xs-center>
            <span class="first">
              <h1 class="white--text">BIENVENUE SUR HIROPAY</h1>
              <p>Votre meilleur plateforme d'échange de cryptomonnaies</p>
              <div v-for="element in elements" :key="element.id">
                <v-list-item>
                  <v-list-item-content>
                    <v-icon color="white">check</v-icon>
                    <v-list-item-title> {{element.text}} </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </span>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 md6 second class="mt-3" > 

     <div id="registerForm" >
    <v-card color="#D8E3E2" class="mx-auto" >
    <v-card-title primary-title>
        <v-flex xs12 text-xs-center>
          <h2>Inscription</h2>
        </v-flex>
    </v-card-title>
      <v-card-text v-if="formulaire" >
        <!-- <strong class="red--text">Option désactivée revenez après un instant </strong> -->
        <p class="subheading" v-if="sponsor ">Sponsor: {{sponsor||'aucun'}} </p>
        <v-form class="px-0" ref="form" @submit.prevent="submit">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                prepend-icon="email"
                required
              ></v-text-field>

              <!-- <div>
                <v-text-field v-model="lastName" label="Nom" prepend-icon="person" :rules="nameRules" required></v-text-field>
              <v-text-field v-model="firstName" label="Prenom" prepend-icon="person" :rules="nameRules" required></v-text-field>
              </div> -->
              
              <v-text-field  type="number" v-model="phone_number" label="Numero de Telephone" prepend-icon="phone" :rules="nameRules" required></v-text-field>
            <v-select

              v-model="country"
              :items="items"
              label="Pays"
              solo
              :rules="nameRules"
              prepend-icon="location_on"
            ></v-select>

              <v-text-field
                v-model="password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Mot de passe"
                hint="Minimum 6 caractères"
                counter
                @click:append="show1 = !show1"
                prepend-icon="lock"
              ></v-text-field>
              <label for="" class="mr-3">CODE PIN</label>
              <input
                      class="code"
                      v-model="pin"
                      type="number"
                      onkeypress="if(this.value.length==4) return false;"
                      required

                    />
              <p class="red--text ">Ce CODE PIN est obligatoire lors du retrait veuillez ne pas l'oublier</p>
              <span><v-checkbox style="display: inline-block;"  v-model="terms_accepted" value=""> 
              </v-checkbox></span>
              <span >En créant un compte, j'accepte <a color="primary"  flat style="display: inline; font-style: italic; text-transform: lowercase ;" @click="$router.push('/terms')">les conditions d'utilisation et la politique de confidentialite</a> de HIROPAY.</span>
              <p v-if="!terms_accepted"  class="red--text " caption>vous devez accepter les termes et conditions et la politique de confidentialité pour vous inscrire</p>
              
            <v-flex xs12 text-xs-center>
              <v-btn class="success" :loading="load" type="submit" :disabled ="!terms_accepted" >S'inscrire</v-btn>
              <P>Déja inscrit? <v-btn  router :to="'/login'" color="primary" flat >Se connecter</v-btn></P>
            </v-flex><br>
            
        </v-form>
      </v-card-text>
      <v-card-text v-if="success">
          <v-flex xs12 text-xs-center>
              <img src="/img/success.svg" alt="success">
          <h3 class="green--text">Votre compte a été créé avec succès, Veillez confirmer votre Email pour vous connecter</h3><br>
          <v-btn color="success" @click="log">OK</v-btn>
          </v-flex>
      </v-card-text>
    </v-card>
      </div>
      </v-flex>
    </v-layout>
  </div>
</template>
 
<script>
var bcrypt = require('bcryptjs');
import axios from 'axios'
import db from '../db'
import firebase from '../fb'
export default {

  name: 'RegisterPage', // ou autre nom de composant
  metaInfo() {
    return {
      title: 'Inscription - HIROPAY : Rejoignez la plateforme de change de devises et cryptomonnaies',
      meta: [
        {
          name: 'description',
          content: `Inscrivez-vous sur HIROPAY, la plateforme de référence pour le change de devises et cryptomonnaies en Franc CFA XOF. Créez un compte dès aujourd'hui pour acheter, vendre et échanger en toute simplicité dans les pays de la zone CFA.`,
        },
        {
          name: 'keywords',
          content: 'Inscription, HIROPAY, change de devises, cryptomonnaies, Franc CFA XOF, Bitcoin, échange monnaie digitale, Togo, Bénin, Côte d’Ivoire, Burkina Faso, Sénégal, Guinée-Bissau, Mali, Niger',
        },
        {
          name: 'author',
          content: 'HIROPAY',
        },
        {
          property: 'og:title',
          content: 'Inscription - HIROPAY : Change de devises et cryptomonnaies',
        },
        {
          property: 'og:description',
          content: `Rejoignez HIROPAY dès aujourd'hui et profitez d'une plateforme sécurisée pour échanger devises traditionnelles et cryptomonnaies comme le Bitcoin en Franc CFA XOF.`,
        },
        {
          property: 'og:image',
          content: 'https://hiropay.com/img/orange.svg', // Remplacez par une image pertinente
        },
        {
          property: 'og:url',
          content: 'https://hiropay.com/register',
        },
      ],
    };
  },

  data() {
      return {
          elements: [
              {id:1, text:'Echange automatisé et en temps réel'},
              {id:2, text:'Fiabilité et éfficacité'},
              {id:3, text:'Sécurité maximale'}
          ],
      email: "",
      terms_accepted:false,
      password: "",
      firstName: "",
      lastName: "",
      country: "",
      load: false,
      formulaire:true,
      show1:false,
      success:false,
      sponsor:'',
      pin:null,
      phone_number:'',
      server: process.env.SERVER,
      emailRules: [
        v => !!v || "E-mail requis",
        v => /.+@.+/.test(v) || "E-mail n'est pas valide"
      ],
      rules: {
        required: value => !!value || "Obligatoire",
        min: v => v.length >= 6 || "Min 6 charactères",
        pin: v => v.length ==4 || "4 chiffres"
      },
      nameRules: [v => !!v || "obligatoire"],
      items: ["Togo","Benin","Burkina Faso","Burundi","Cameroun", "Cote d'ivoire","Guinee","Gabon","Ghana","Mali","Mauritanie", "Niger","RDC","Senegal","Centrafrique" ]
      }
  },
  mounted () {
    var idp = this.$route.params.id || null
    let server = `${this.base_url}/db_access/get_sponsor`
    if (location.hostname === "localhost") {
      server = 'http://localhost:4000/db_access/get_sponsor'
    }
    axios.post(server, {sponsor: idp}).then(result => {
      console.log(result.data);
      this.sponsor = result.data
    })
  },
  methods: {
    async submit() {
      var idp=this.$route.params.id||'aucun'
      var pin =this.pin
      bcrypt.genSalt(10, (err, salt)=> {
        bcrypt.hash(pin, salt, async (err, hash)=>{
        console.log(hash);
        if (this.$refs.form.validate()) {
          if (this.pin && this.pin.length==4) {
            console.log((this.pin));
            let email = this.email
            email  = email.replace(/\s/g, '');
            this.load = true;
            let payload = {
                email,
                country: this.country,
                firstName: this.firstName,
                lastName:this.lastName,
                password: this.password,
                phone_number: Number(this.phone_number),
                sponsor:idp,
                pin:hash
              }
              console.log(payload);
              const basic_auth = this.axios_auth
              let server = `${this.base_url}/auth_pay/signup`
              if (location.hostname === "localhost") {
              server = 'http://localhost:4000/auth_pay/signup'
          }
            axios.post(`${server}`, payload, basic_auth).then(res=>{
               let {data} = res
               console.log(data);
              if (data.message == 'error') {
                this.load=false;
                if (data.code==='auth/invalid-email') {
                  swal("Email mal écrit", " Verifiez votre email et assurez vous qu'il n'y est pas d'espace au début ou à la fin!", "error", {
                    button: "ok"
                  })
                }else if (data.code==='auth/email-already-exists') {
                  swal("compte déjà existant", "ce compte existe déjà sur HIROPAY veuillez pluto vous connecter!", "error", {
                    button: "ok"
                  })
                }
                return
              }
              this.load=false;
              this.$refs.form.reset();
              this.formulaire=false;
              this.success=true

            })

          }else{
             swal("Erreur PIN", "le CODE PIN est obligatoire et servira lors du retrait", "error", {
            button: "ok"
          })
          }
        
      }
        
    });
});
  
    },
    log(){
         this.$router.push("/login");
    }
  }
};
</script> 
 
<style scoped lang="scss">

div.tout{

    height: 100%;
    background-image: url("/img/global.png");
    background-color: #003449;
    font-family: 'Titillium Web',sans-serif !important;
}
#registerForm{
    position: relative;
    padding-left: 25px;
    margin-right: 25px;
}
h1.mobile{
  font-family: 'Titillium Web',sans-serif !important;
  font-weight: bold !important;
}
div.v-card{
    max-width: 500px;
    margin-top: 3vh;
  position: relative;
  
    
}
div.v-list{
    background-color: #D8E3E2 !important;
}

h1 {
  font-weight: 300 !important;
  font-size: 34px !important;
  line-height: 1.5;
  margin-bottom: 10px;
}
span.first {
  margin-top: 20vh;
  position: absolute;
  color: #ffffff;
}

$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 4;
$in-w: $n-char * ($char-w + $gap);

input.code {
  display: inline-block;
  margin-bottom: 1em;
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(
      90deg,
      dimgrey 0,
      dimgrey $char-w,
      transparent 0,
      transparent $char-w + $gap
    )
    0 100% / #{$in-w - $gap} 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: $gap;

  &:focus {
    outline: none;
    color: dodgerblue;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


</style> 